<template>
  <div class="h-full w-full relative flex items-end pb-12">
    <img
      src="../assets/images/on-boarding-bg.png"
      class="h-full w-full object-cover absolute top-0 left-0 -z-[1]"
    />
    <div class="flex flex-col items-center w-full justify-center gap-10">
      <div class="flex flex-col gap-2 items-center justify-center">
        <div class="w-6 h-6 border-r-2 border-green-500 animate-spin rounded-full"></div>
        <p class="text-white font-semibold text-sm">{{ text }}</p>
      </div>
      <div class="flex flex-col gap-5 items-center justify-center">
        <p class="text-base font-medium">Find Us On</p>
        <div class="flex items-center gap-4">
          <div class="h-10 w-10 bg-white rounded-full flex items-center justify-center">
            <font-awesome-icon icon="fa-brands fa-telegram" class="black-icon" size="lg" />
          </div>
          <div class="h-10 w-10 bg-white rounded-full flex items-center justify-center">
            <font-awesome-icon :icon="['fab', 'youtube']" class="black-icon" size="lg" />
          </div>
          <div class="h-10 w-10 bg-white rounded-full flex items-center justify-center">
            <font-awesome-icon icon="fa-brands fa-x-twitter" class="black-icon" size="lg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const text = ref('Waiting for connection...')

setTimeout(() => {
  text.value = 'Loading'
}, 1000)
</script>
